'use client'
import styles from '../../OnboardingForm.module.scss'
import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'
import CheckboxGroup from '@/src/components/common/CheckboxGroup'
import Select from '@/src/components/common/Select'
import imgHeart from './icons/favorite_border.svg'
import imgHelp from './icons/help_outline.svg'
import imgCleaning from './icons/cleaning_services.svg'
import imgMedical from './icons/medical_services.svg'
import imgPeople from './icons/people_outline.svg'
import imgTransport from './icons/time_to_leave.svg'

export default function WithHomecarePackageMoreDetailsForm() {
  const [onboardingData] = useState(readStoredData())

  return (
    <>
      <div>
        <div>
          <h3 className={styles.heading}>
            {`Which Support at Home funding level are you currently assigned to?`}
          </h3>
          {`Your funding level is listed in your My Aged Care letter from your assessment. If you’re not sure, that’s no problem. We're here to help.`}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {`Please select your Support at Home funding level`}
          {(() => {
            const name = 'more_details__with_hcp__package_level'
            const options = [
              'Level 1',
              'Level 2',
              'Level 3',
              'Level 4',
              'Level 5',
              'Level 6',
              'Level 7',
              'Level 8',
              'I’m not sure',
            ]
            const selectedIdx = options.indexOf(onboardingData.data?.[name] as string)
            return (
              <Select
                required
                name={name}
                default={selectedIdx < 0 ? null : selectedIdx}
                options={options}
              />
            )
          })()}
        </div>

        <hr />

        <div>
          <h3 className={styles.heading}>
            {`What kind of support are you most interested in right now?`}
          </h3>
          {`You can select more than one option`}
        </div>

        {(() => {
          const name = 'more_details__with_hcp__support'
          const values =
            typeof onboardingData.data?.[name] === 'string'
              ? [onboardingData.data?.[name]]
              : (onboardingData.data?.[name] ?? [])
          return (
            <CheckboxGroup
              required={1}
              options={[
                { icon: imgHeart.src, value: 'Personal care (ex: bathing, dressing)' },
                { icon: imgCleaning.src, value: 'Domestic help (ex: cleaning, cooking)' },
                { icon: imgMedical.src, value: 'Nursing or medical support' },
                { icon: imgPeople.src, value: 'Social support or companionship' },
                { icon: imgTransport.src, value: 'Transport or errands' },
                { icon: imgHelp.src, value: 'Other / I’m not sure' },
              ]}
              name={name}
              values={values as string[]}
              className={styles.iconCardOptions}
            />
          )
        })()}
      </div>
    </>
  )
}
